import { Component } from '@angular/core';

@Component({
	selector: 'app-itc-busy',
	styleUrls: ['./itc-busy.component.scss'],
	templateUrl: './itc-busy.component.html',
})
export class ItcBusyComponent {}
